import { Link } from 'react-router-dom';
import { useEffect, useRef } from 'react';
import { ScrollTrigger } from "gsap/ScrollTrigger";
import healthSquare from './../../assets/images/health-shapes-square.svg';
import healthTriangle from './../../assets/images/health-shapes-triangle.svg';
import barChart from './../../assets/images/health-bar-chart.svg';
import '../health.scss';
import { gsap } from 'gsap';
import AOS from "aos";
import "aos/dist/aos.css";

export default function HealthUsage() {

  const square1Ref = useRef();
  const square2Ref = useRef();
  const triangle1Ref = useRef();
  const triangle2Ref = useRef();

  gsap.registerPlugin(ScrollTrigger);

  useEffect(() => {

    document.addEventListener('aos:in:bar-anim', function(ev) {
      //console.log('animated in', ev);

      if (ev.detail.querySelectorAll('.progress').length > 1) {
        console.log("more than 1 progress");
        var barArray = [...ev.detail.querySelectorAll('.progress')];
      } else {
        console.log("less than 1 progress");
        var barArray = [];
        var bar = ev.detail.querySelector('.progress');
        console.log(bar);
        barArray.push(bar);
      }

      console.log(barArray);

      if (barArray && barArray.length) {
        barArray.forEach(function(barItem) {
          var fill = barItem.getAttribute('data-fill');

          if (ev.detail.classList.contains('vertical-bar-chart')) {
            barItem.style.height = fill + '%';
          }

          if (!ev.detail.classList.contains('vertical-bar-chart')) {
            barItem.style.width = fill + '%';
          }

        });
      }

      var Cont={val:0};

      if (ev.detail.querySelectorAll('.percentage').length > 1) {
        var percentageArray = [...ev.detail.querySelectorAll('.percentage')];
        console.log("more than 1 percentage");
      } else {
        var percentageArray = [];
        var percentage = ev.detail.children[0].querySelector('.percentage');
        percentageArray.push(percentage);
        console.log("less than percentage");

      }

      //console.log(percentage);

      if (percentageArray) {
        percentageArray.forEach(function(percentage) {
          var percent = percentage.getAttribute('data-to');
            gsap.to(Cont,1,{val:percent,roundProps:"val",onUpdate:function(){
              percentage.textContent = Cont.val;
            },
            ease: "none"});
          
        });
      }

      console.log(percentageArray);

    });

    document.addEventListener('aos:in:percentage', function(ev) {
      var Cont={val:0};
      var percentage = ev.detail.children[0].querySelector('.percentage');
      var percentageArray = [];
      percentageArray.push(percentage);
      //console.log(percentage);

      if (percentage) {
        percentageArray.forEach(function(percentage) {
          var percent = percentage.getAttribute('data-to');
            gsap.to(Cont,1,{val:percent,roundProps:"val",onUpdate:function(){
              percentage.textContent = Cont.val;
            },
            ease: "none"});
          
        });
      }
    });

    // Had to make some adjustments since it seemed like the animation wasn't playing nice with React. The shapes weren't incrementing exactly 90 degrees (it was adding a few degrees with decimal places) so they always rotated crooked. Possibly React strict mode causing issues. Added gsap.context, refs, and using GSAP's ScrollTrigger instead of AOS. 
    let ctx = gsap.context(() => {

      var tl = gsap.timeline({ 
        onComplete:rotateAgain,
        scrollTrigger: {
          trigger: ".shape-images"
        }
      });

      function animate(){
        tl
        .to(triangle1Ref.current, 0.5, {rotation:"+=90"})
        .to(square1Ref.current, 0.5, {rotation:"+=90"}, "+=2")
        .to(triangle2Ref.current, 0.5, {rotation:"+=90"}, "+=2")
        .to(square2Ref.current, 0.5, {rotation:"+=90"}, "+=2")
      }

      function rotateAgain(){
        gsap.delayedCall(5, animate)
      }

      animate();

    });

    return () => { ctx.revert(); /* <- cleanup! */ };


  }, []);

  useEffect(() => {
    AOS.init({
      once: true
    });
    AOS.refresh();
  }, []);

  return (
    <>
      <div className="health-usage">
        <p id="s1" className="intro" data-aos="fade-up">Dive into proprietary stats and insights to see how today’s health companies make use of direct mail.&#8288;<a href="#reference-1" class="cm-article-content__reference" aria-label="Footnote 1" title="Footnote 1"><sup aria-hidden="true">[1]</sup></a></p>
        <div className='two-cols'>
          <div className='col-left'>
            <div className='rounded-box-module-wrap'>
              <div className="rounded-box-module" data-aos="fade-up">
                <h3>Marketing Effectiveness</h3>

                <p className="pull-quote"><span data-aos className='highlighter'>68%</span> of health businesses find direct mail  <span data-aos className='highlighter'>effective.</span></p>
                <p>Health companies find direct mail to be more effective than internet advertising, paid search, magazine or newspaper ads, TV ads, billboards/outdoor advertising, and radio ads.</p>
                <p>Overall, health businesses consider social the most effective marketing channel. </p>
              </div>
              <div className="rounded-box-module">
                <div className='heading-tag'><span className='heading-tag_span'>Pro tip</span></div>
                <p>Even in the age of digital, many patients and customers may prefer bills, appointment reminders and more in physical form. Sending these via direct mail can help break through the digital clutter, helping ensure recipients see your communications; some may even keep reminders on the refrigerator or desk, meaning your business will be top of mind.</p>
              </div>
            </div>

            <div className='inner-cols'>
              <div className='inner-col-item'>
                <div className='rounded-box-module-wrap'>
                  <div className="rounded-box-module" data-aos="fade-up">
                    <h3>Direct Mail Techniques</h3>
                    
                    <div className='progress-bar-area' data-aos data-aos-id="bar-anim">
                      <div className='progressbar-item'>
                        <span className='label'>Personalized offers</span>
                        <div className='progress-bar size-small'>
                          <div className='progress' data-fill="56"><span class="percentage" data-to="56" aria-hidden="true">0</span><span class="screen-reader-text">56</span>%</div>
                        </div>
                      </div>
                      <div className='progressbar-item'>
                        <span className='label'>Personalized greetings or customer/patient names</span>
                        <div className='progress-bar size-small'>
                          <div className='progress' data-fill="56"><span class="percentage" data-to="56" aria-hidden="true">0</span><span class="screen-reader-text">56</span>%</div>
                        </div>
                      </div>
                    </div>
                    <p>Among health companies, personalization is the most common direct mail technique, whether in the form of personalized offers or greetings.</p>
                  </div>
                  <div className="rounded-box-module">
                    <div className='heading-tag'><span className='heading-tag_span'>Pro tip</span></div>
                    <p>Personalized mail can be an effective way to encourage customers or patients to act. <strong><a href="/../evolution-of-a-medium/retargeted-direct-mail">Retargeted direct mail,</a></strong> for example, allows you to follow up with those who showed interest in your business online. Try including a reminder—and if possible, an incentive—to encourage them to make a purchase or schedule an appointment.</p>
                  </div>
                </div>
              </div>
              
              <div className='inner-col-item'>
                <div className='personalized-box secondary align-to-text'>
                  <h3>Personalized mail can help encourage recipients to act.</h3>
                  <div className='shape-images'>
                    <div className='triangle triangle-1'>
                      <img ref={triangle1Ref} src={healthTriangle} alt="" />
                    </div>
                    <div className='square square-1'>
                      <img ref={square1Ref} src={healthSquare} alt="" />
                    </div>
                    <div className='triangle triangle-2'>
                      <img ref={triangle2Ref} src={healthTriangle} alt="" />
                    </div>
                    <div className='square square-2'>
                      <img ref={square2Ref} src={healthSquare} alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='col-right'>
            
            <div className='rounded-box-module-wrap'>
              <div className="rounded-box-module" data-aos="fade-up">
                <h3>Direct Mail and the Customer Journey</h3>

                <div className='progress-bar-area vertical-bar-chart' data-aos data-aos-id="bar-anim" data-aos-offset="300">
                  <div className='progressbar-item'>
                    <div className='progress-bar'>
                      <div className='progress fill-light' data-fill="29"><span class="percentage" data-to="29" aria-hidden="true">0</span><span class="screen-reader-text">29</span>%</div>
                    </div>
                    <span className='label'>Drive awareness</span>
                  </div>
                  <div className='progressbar-item'>
                    <div className='progress-bar'>
                      <div className='progress' data-fill="34"><span class="percentage" data-to="34" aria-hidden="true">0</span><span class="screen-reader-text">34</span>%</div>
                    </div>
                    <span className='label'>Drive growth</span>
                  </div>
                  <div className='progressbar-item'>
                    <div className='progress-bar'>
                      <div className='progress fill-light' data-fill="18"><span class="percentage" data-to="18" aria-hidden="true">0</span><span class="screen-reader-text">18</span>%</div>
                    </div>
                    <span className='label'>Drive leads</span>
                  </div>
                  <div className='progressbar-item'>
                    <div className='progress-bar'>
                      <div className='progress fill-light' data-fill="19"><span class="percentage" data-to="19" aria-hidden="true">0</span><span class="screen-reader-text">19</span>%</div>
                    </div>
                    <span className='label'>Drive loyalty</span>
                  </div>
                </div>

                <p>Out of all the industries surveyed, health companies are the most likely to use direct mail to drive growth.</p>
              </div>
              <div className="rounded-box-module">
                <div className='heading-tag'><span className='heading-tag_span'>Pro tip</span></div>
                <p>To drive growth through direct mail, create messaging that speaks directly to customers and patients’ wants and needs, using data to inform any offers and messaging you send; for example, older patients or customers will likely have different concerns than younger ones. Also consider the value of timely communications—whether for allergy or flu seasons, the back-to-school period, or something else.</p>
              </div>
            </div>
          </div>
        </div>
      </div>


    </>
  );
}
